/* global require setTimeout clearTimeout */
import Vue from "vue";
import EventBus from "./event-bus";

export default Vue.component("image-viewer-marker", {
  props: [
    // The fragment number within the image
    "index",
    // Fragment id. Used to link to own image page
    "id",
    // x position in full res image
    "x",
    // y position in full res image
    "y",
    // Current pan (x/y offset) of parent image viewer
    "pan",
    // Current scale of parent image viewer
    "scale"
  ],

  data() {
    return {
      // Is marker expanded (happen on hover)
      isExpanded: false,
      // Used when another marker is shown solo
      isHidden: false,
      mouseEventTimeout: NaN,
      classNames: {
        main: "c-image-viewer-marker"
      }
    };
  },

  computed: {
    style() {
      return {
        // Position based on original pos and current pan and scale
        left: this.pan.left + this.x / this.scale + "px",
        top: this.pan.top + this.y / this.scale + "px",
        // Make sure focused marker is on top
        zIndex: this.isExpanded ? 2 : 1,
        // Handle visibility
        display: this.isHidden ? "none" : undefined
      };
    },

    classes() {
      return {
        [this.classNames.main]: true
      };
    },

    // The text to render on the marker
    text() {
      return this.isExpanded ? this.id : this.index;
    }
  },

  methods: {
    onMouseEnter() {
      // Wait a but so css width transition is complete
      this.mouseEventTimeout = setTimeout(() => {
        // Expand
        this.isExpanded = true;
      }, 50);
    },

    onMouseLeave() {
      // Cancel queued expansions
      clearTimeout(this.mouseEventTimeout);
      // Collapse
      this.isExpanded = false;
    },

    // Init external events bus handlers
    initExternalEventHandlers() {
      const self = this;
      let hideTimeout = NaN;
      // Handle interaction with external fragment list item
      EventBus.$on("fragmentList.fragment.focus", (index) => {
        // Hide unless index matches
        self.isHidden = !(index == self.index);
      });
      // Handle interaction with external fragment list
      EventBus.$on("fragmentList.focus", () => {
        // Hide since parent is now visible
        self.isHidden = true;
        clearTimeout(hideTimeout);
      });
      // Handle interaction end
      EventBus.$on("fragmentList.blur", () => {
        // Wait so parent fade out is complete
        hideTimeout = setTimeout(() => {
          // Show since parent is no longer visible
          self.isHidden = false;
        }, 200);
      });
    }
  },

  mounted() {
    this.initExternalEventHandlers();
  },

  template: require("./templates/image-viewer-marker.html")
});



// WEBPACK FOOTER //
// ./src/frontend/common/image-viewer/image-viewer-marker.js